module.exports = __webpack_public_path__ + "img/text.33340bd0.svg";